import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ConfirmationModal } from "isuppli-react-components";
import { useLocation } from "react-router";

import { getUserBasicDetails } from "../../http/core/core";
import { clearNotAuthenticated } from "../../store/actions";
// eslint-disable-next-line no-unused-vars
import { ReduxState } from "../../store/ReduxState";

const AuthenticatedHandler = ({ children }: {children: React.ReactNode}) => {
  const authenticationState = useSelector((state: ReduxState) => state.authentication);
  const dispatch = useDispatch();
  const location = useLocation();
  const userBasicDetails = useSelector((state: ReduxState) => state.userBasicDetails);

  if (location.pathname === "/re-authenticate-callback") {
    window.close();
    window.opener.reAuthenticateCallback();
  }

  useEffect(() => {
    // setup child view callback
    (window as any).reAuthenticateCallback = async () => {
      const newUserDetails = await getUserBasicDetails({ bypassSessionExpiryCheck: true });
      // check if company has changed
      if (userBasicDetails?.companyId !== newUserDetails.companyId) {
        window.location.reload();
      } else {
        authenticationState.retryHandlers.forEach((retry) => {
          retry();
        });
      }

      dispatch(clearNotAuthenticated());
    };
  }, [userBasicDetails, authenticationState, dispatch]);
  return (
    <>
      {!authenticationState.isAuthenticated && (
        <ConfirmationModal
          image="error"
          hasCancel={false}
          heading="Session Expired"
          description="You have been automatically logged out due to inactivity. Do you want to log in again?"
          proceedButtonText="Log In"
          onToggleModal={() => { }}
          onProceedClick={() => {
            window.open("Account/ReAuthenticate", "_blank", "width=450, height=700");
          }}
        />
      )}
      {children}
    </>
  );
};

export default AuthenticatedHandler;
